var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ui, mvc, util } from '@joint/plus';
import { COLORS, FONT_FAMILIES, FONT_SIZES } from './config';
var RichTextToolbar = /** @class */ (function (_super) {
    __extends(RichTextToolbar, _super);
    function RichTextToolbar(options) {
        var _this = _super.call(this, options) || this;
        _this.updateInputsDebounced = util.debounce(function (attrs) {
            _this.updateInputs(attrs);
        }, 50);
        return _this;
    }
    RichTextToolbar.prototype.preinitialize = function () {
        this.className = 'rich-text-toolbar';
        this.defaultTheme = null;
    };
    RichTextToolbar.prototype.init = function () {
        var _this = this;
        var _a = this.options.openPolicy, openPolicy = _a === void 0 ? 'coverBelow' : _a;
        // Text Color
        var textColorInput = new ui.ColorPalette({
            target: this.el,
            placeholder: 'N/A',
            openPolicy: openPolicy,
            options: COLORS.map(function (color) { return ({ content: color }); }),
        });
        textColorInput.render();
        textColorInput.on('option:select', function (_option, _index, opt) {
            if (opt.silent)
                return;
            _this.setCurrentAnnotation();
        });
        this.el.appendChild(textColorInput.el);
        this.textColorInput = textColorInput;
        // Text Style
        var textStyleInput = new ui.SelectButtonGroup({
            multi: true,
            selected: [],
            options: [
                { value: 'underline', content: '<span style="text-decoration: underline">U</span>' },
                { value: 'italic', content: '<span style="font-style: italic">I</span>' },
                { value: 'bold', content: '<span style="font-weight: bold">B</span>' }
            ]
        });
        textStyleInput.render();
        textStyleInput.on('option:select', function (_option, _index, opt) {
            if (opt.silent)
                return;
            _this.setCurrentAnnotation();
        });
        this.el.appendChild(textStyleInput.el);
        this.textStyleInput = textStyleInput;
        // Font Size
        var fontSizeInput = new ui.SelectBox({
            openPolicy: openPolicy,
            target: this.el,
            width: 150,
            placeholder: 'N/A',
            options: FONT_SIZES.map(function (size) { return ({ content: size }); })
        });
        fontSizeInput.render();
        fontSizeInput.on('option:select', function (_option, _index, opt) {
            if (opt.silent)
                return;
            _this.setCurrentAnnotation();
        });
        this.el.appendChild(fontSizeInput.el);
        this.fontSizeInput = fontSizeInput;
        // Font Family
        var fontFamilyInput = new ui.SelectBox({
            openPolicy: openPolicy,
            target: this.el,
            width: 150,
            placeholder: 'N/A',
            options: FONT_FAMILIES.map(function (font) {
                var fontName = font.split(',')[0];
                return {
                    value: font,
                    content: "<span style=\"font-family:".concat(font, "\">").concat(fontName, "</span>")
                };
            })
        });
        fontFamilyInput.render();
        fontFamilyInput.on('option:select', function (_option, _index, opt) {
            if (opt.silent)
                return;
            _this.setCurrentAnnotation();
        });
        this.el.appendChild(fontFamilyInput.el);
        this.fontFamilyInput = fontFamilyInput;
        // Clear Formatting
        var clearFormattingButton = document.createElement('button');
        clearFormattingButton.className = 'clear-formatting-button';
        clearFormattingButton.textContent = 'Ⱦ';
        clearFormattingButton.addEventListener('click', function () {
            _this.resetAnnotation();
        });
        this.el.appendChild(clearFormattingButton);
        this.clearFormattingInput = clearFormattingButton;
    };
    RichTextToolbar.prototype.enable = function () {
        this.textColorInput.enable();
        this.textStyleInput.enable();
        this.fontSizeInput.enable();
        this.fontFamilyInput.enable();
        this.clearFormattingInput.disabled = false;
    };
    RichTextToolbar.prototype.disable = function () {
        this.textColorInput.disable();
        this.textStyleInput.disable();
        this.fontSizeInput.disable();
        this.fontFamilyInput.disable();
        this.clearFormattingInput.disabled = true;
    };
    RichTextToolbar.prototype.onRemove = function () {
        this.textColorInput.remove();
        this.textStyleInput.remove();
        this.fontSizeInput.remove();
        this.fontFamilyInput.remove();
    };
    RichTextToolbar.prototype.resetAnnotation = function () {
        var options = this.options;
        var _a = options.defaultAttributes, defaultAttributes = _a === void 0 ? {} : _a, _b = options.setAttributes, setAttributes = _b === void 0 ? function () { } : _b;
        var attrs = Object.assign({}, defaultAttributes);
        setAttributes(attrs);
        this.updateInputs(attrs);
    };
    RichTextToolbar.prototype.setCurrentAnnotation = function () {
        var _a = this, options = _a.options, textColorInput = _a.textColorInput, textStyleInput = _a.textStyleInput, fontSizeInput = _a.fontSizeInput, fontFamilyInput = _a.fontFamilyInput;
        var _b = options.defaultAttributes, defaultAttributes = _b === void 0 ? {} : _b, _c = options.setAttributes, setAttributes = _c === void 0 ? function () { } : _c;
        var textStyle = textStyleInput.getSelectionValue();
        var textColor = textColorInput.getSelectionValue();
        var fontSize = fontSizeInput.getSelectionValue();
        var fontFamily = fontFamilyInput.getSelectionValue();
        var attrs = Object.assign({}, defaultAttributes);
        if (fontSize === undefined) {
            delete attrs['font-size'];
        }
        else {
            attrs['font-size'] = parseInt(fontSize, 10);
        }
        if (fontFamily === undefined) {
            delete attrs['font-family'];
        }
        else {
            attrs['font-family'] = fontFamily;
        }
        if (textColor === undefined) {
            delete attrs['fill'];
        }
        else {
            attrs['fill'] = textColor;
        }
        if (textStyle.includes('bold')) {
            attrs['font-weight'] = 'bold';
        }
        else if (this.fontWeightUndefined) {
            delete attrs['font-weight'];
        }
        if (textStyle.includes('italic')) {
            attrs['font-style'] = 'italic';
        }
        else if (this.fontStyleUndefined) {
            delete attrs['font-style'];
        }
        if (textStyle.includes('underline')) {
            attrs['text-decoration'] = 'underline';
        }
        else if (this.textDecorationUndefined) {
            delete attrs['text-decoration'];
        }
        this.fontWeightUndefined = false;
        this.fontStyleUndefined = false;
        this.textDecorationUndefined = false;
        setAttributes(attrs);
    };
    RichTextToolbar.prototype.updateInputs = function (attrs) {
        var _a = this, textColorInput = _a.textColorInput, textStyleInput = _a.textStyleInput, fontSizeInput = _a.fontSizeInput, fontFamilyInput = _a.fontFamilyInput;
        var silently = { silent: true };
        if (attrs['fill']) {
            textColorInput.selectByValue(attrs['fill'], silently);
        }
        else {
            textColorInput.select(-1, silently);
        }
        if (attrs['font-size']) {
            fontSizeInput.selectByValue(attrs['font-size'] + 'px', silently);
        }
        else {
            fontSizeInput.select(-1, silently);
        }
        if (attrs['font-family']) {
            fontFamilyInput.selectByValue(attrs['font-family'], silently);
        }
        else {
            fontFamilyInput.select(-1, silently);
        }
        textStyleInput.deselect();
        if (attrs['font-weight'] === undefined) {
            this.fontWeightUndefined = true;
        }
        else if (attrs['font-weight'] === 'bold') {
            textStyleInput.selectByValue('bold', silently);
        }
        if (attrs['text-decoration'] === undefined) {
            this.textDecorationUndefined = true;
        }
        else if (attrs['text-decoration'] === 'underline') {
            textStyleInput.selectByValue('underline', silently);
        }
        if (attrs['font-style'] === undefined) {
            this.fontStyleUndefined = true;
        }
        else if (attrs['font-style'] === 'italic') {
            textStyleInput.selectByValue('italic', silently);
        }
    };
    return RichTextToolbar;
}(mvc.View));
export { RichTextToolbar };
